<template>
  <div class="account-page">
<div class="main-wrapper">
  <layout-header></layout-header>
  <div class="main_home_content">
<div class="container">
  <div class="row">
    <div class="col-md-10 offset-md-1 pt-1 pb-5" style="margin-top: 40px;">
      <div class="home-content">
        <div class="row align-items-center justify-content-center">
          <div class="col-md-7 col-lg-6">
            <h2 class="right_heading">
              Receipt Issuance & Financial Management:
            </h2>
            <h4 class="right_headline">
              Effortless Financial Transactions in Healthcare
            </h4>
            <h5 class="right_content">
              {{main_data}} Seamless Receipt Issuance &
              Comprehensive Financial Management
            </h5>
            <p class="right_content">
              Financial management in healthcare encompasses more than just
              payments – it's about transparency, accuracy, and efficiency.
              {{main_data}} introduces a robust system for Receipt
              Issuance & Financial Management, ensuring that both patients
              and healthcare providers have a smooth and transparent
              financial experience
            </p>
            <div style="margin-top: 50px;"></div>
          </div>
          <div class="col-md-12 col-lg-6">
            <img style="height: 350px;"
              src="@/assets/img/financialmanagement.jpeg"
              class="img-fluid"
              alt="Doccure Login"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="container">
<div class="text-center mt-4">
<h3 style="margin-bottom: 30px; margin-top: 30px;">
  Automated Receipt Generation:
</h3>
</div>
</div>

<div class="container">
<div class="text-center mt-4 mb-4">
<div class="card" style="max-width: 400px; margin: 0 auto;">
  <div class="card-header bg-dark text-white">
    Instant Receipts for Every Transaction
  </div>
  <div class="card-body">
    Generate detailed and accurate receipts automatically for every patient transaction, be it consultations, procedures, or any other service.
  </div>
</div>
</div>
</div>


</div>
<layout-footer></layout-footer>
</div>
</div>
</template>
<script>
import config from "../../services/CommonApi";
import axios from "axios";
export default {
  data() {
    return {
      main_data: "",
      config: config,
    };
  },
  mounted() {
    this.get_practitioner_profile();
  },
  methods: {

    async get_practitioner_profile() {
      var domain = window.location.hostname;

      const formdata = {
        domain: window.location.hostname,
      };
      await axios
        .get(
          "https://develop-physio.kneexpert.in/api/method/sahaj.domain.get_hospital?domain=" +
          window.location.hostname
        )
        .then((res) => {
          this.showspinner = false;
          if (res.data.status_code == 200) {
            this.main_data = res.data.data[0].brand_name
          }
          if (res.data.status_code == 404) {
            if (window.location.hostname == "physio.sahajhelp.com") {
            } else if (window.location.hostname == "physio.kneexpert.in") {
            } else if (window.location.hostname == "localhost") {
            }
            else if (window.location.hostname.startsWith("192.168")) {
            } else if (window.location.hostname == "iitb.smartyhealthcare.in") {
            } else {
              window.location.href = String("https://physio.kneexpert.in");
            }
          }
          this.$swal.close();
        });
    },

  },
}
</script>



<style>
.right_heading {
font-size: 40px;
font-weight: bold;
font-family: sans-serif;
}

.right_content {
font-size: 16px;
margin-top: 20px;
font-family: sans-serif;
}
.right_headline {
margin-top: 20px;
}
.btn {
border-radius: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/kneexpert/FinancialReciept.vue